module.exports = "pegasus/assets/theme4/l_w.png";